
<div  class="val-barre-menus">
  <kendo-menu [items]="menuItems"
              (select)="ExecuterActionSurClickMenu($event)">
    <ng-template kendoMenuItemTemplate let-item="item">
      <div class="val-flex-conteneur val-barre-menus-item">
        <val-fonte-icone [iconeCss]="item.iconeClass"></val-fonte-icone>
        <val-simple-libelle class="val-flex-1" [libelle]="item.libelle | val_libelle_dico: item.dico"></val-simple-libelle>
      </div>
    </ng-template>
  </kendo-menu>
</div>

